import { ArrowDown, ArrowUp, Plus, Trash2 } from 'lucide-react';
import { cn } from '@/lib/utils';

const ControlButton = ({ label, onClick, disabled, danger, children }) => (
  <button
    type="button"
    title={label}
    aria-label={label}
    disabled={disabled}
    onClick={onClick}
    className={cn(
      'w-7 h-7 inline-flex items-center justify-center rounded-md transition-colors disabled:opacity-30 disabled:pointer-events-none',
      danger ? 'text-red-600 hover:bg-red-50 dark:hover:bg-red-500/10' : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/10'
    )}
  >
    {children}
  </button>
);

/** أزرار ترتيب/حذف عنصر (قسم، سؤال...) في وضع التعديل */
export const BlockControls = ({ index, count, onMove, onRemove, label = 'القسم', className }) => (
  <div
    className={cn(
      'inline-flex items-center gap-0.5 rounded-lg border border-gray-200 dark:border-white/10 bg-white dark:bg-gray-900 shadow-sm p-0.5',
      className
    )}
  >
    <ControlButton label="لفوق" disabled={index === 0} onClick={() => onMove(index, -1)}>
      <ArrowUp className="w-4 h-4" />
    </ControlButton>
    <ControlButton label="لتحت" disabled={index === count - 1} onClick={() => onMove(index, 1)}>
      <ArrowDown className="w-4 h-4" />
    </ControlButton>
    <ControlButton
      label={`حذف ${label}`}
      danger
      onClick={() => window.confirm(`حذف ${label}؟`) && onRemove(index)}
    >
      <Trash2 className="w-4 h-4" />
    </ControlButton>
  </div>
);

/** زر "إضافة" منقّط بين العناصر */
export const AddBlockButton = ({ label, onClick, className }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'w-full flex items-center justify-center gap-2 rounded-lg border-2 border-dashed border-burgundy-500/30 hover:border-burgundy-500 hover:bg-burgundy-500/5 text-burgundy-500 font-cairo font-semibold text-sm py-3 transition',
      className
    )}
  >
    <Plus className="w-4 h-4" />
    {label}
  </button>
);
